import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { LoadingProgressType } from "../../interfaces/interfaces";

export interface DataFetchingInf {
  dfProgress: boolean;
  updatesDone: number;
  loadingType: LoadingProgressType;
  extraConfig: { [x: string]: any };
}

const INITIAL_STATE = {
  dfProgress: false,
  updatesDone: 0,
  loadingType: null,
  extraConfig: null,
} as DataFetchingInf;

const DataFetchingSlice = createSlice({
  name: "dataFetchingProgress",
  initialState: INITIAL_STATE,
  reducers: {
    changeDfStatus: (
      state,
      action: PayloadAction<{
        status: number;
        type: LoadingProgressType;
        extraConfig: { [x: string]: any };
      }>
    ) => {
      state.dfProgress = Boolean(action.payload?.status);
      state.loadingType = action.payload?.type;
      state.updatesDone += 1;
      state.extraConfig = action.payload?.extraConfig
        ? action.payload?.extraConfig
        : null;
    },
  },
});

export const { changeDfStatus } = DataFetchingSlice.actions;

export const DataFetchingReducer = DataFetchingSlice.reducer;
